import { render, staticRenderFns } from "./PrivateInner.vue?vue&type=template&id=613e3292&scoped=true"
import script from "./PrivateInner.vue?vue&type=script&lang=js"
export * from "./PrivateInner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613e3292",
  null
  
)

export default component.exports